import { createSelector } from 'reselect';
import { resolveProp } from '@clearscore-group/lib.helpers.resolve-props';

const getUserPreferenceProducts = (state) => resolveProp('profile.data.userPreferences.products', state) || {};

export default createSelector(getUserPreferenceProducts, (products) => products);
